import { ActionType, createAsyncAction } from 'typesafe-actions'
import { UserState } from '../../types'
import { Failure, Request, Success } from './types'

export const fetchOperatorsAction = createAsyncAction(
  '@user/FETCH_OPERATORS_REQUEST',
  '@user/FETCH_OPERATORS_SUCCESS',
  '@user/FETCH_OPERATORS_FAILURE'
)<Request, Success, Failure>()

const request = (state: UserState): UserState => ({
  ...state,
  isLoadingFetchOperators: true,
  isErrorOnLoadingFetchOperators: false,
  isSuccessOnLoadingFetchOperators: false
})

const success = (state: UserState, action: ActionType<typeof fetchOperatorsAction.success>): UserState => ({
  ...state,
  isLoadingFetchOperators: false,
  isErrorOnLoadingFetchOperators: false,
  isSuccessOnLoadingFetchOperators: true,
  users: action.payload.users
})

const failure = (state: UserState): UserState => ({
  ...state,
  isLoadingFetchOperators: false,
  isSuccessOnLoadingFetchOperators: false,
  isErrorOnLoadingFetchOperators: true
})

export const fetchOperatorsHandle = { asyncAction: fetchOperatorsAction, request, success, failure }
